import { redirect } from "@state";
import { getCurrentCulture } from "@utils/common/culture";

/**
 *
 * @param additionalParam additional search param for easier redirect behavior
 * @returns new url with added return url as search param
 */
export function getLoginReturnUrl(additionalParam?: string): string {
	const searchParams = new URLSearchParams(window.location.search);
	const currentUrl = window.location.pathname.slice(3);

	let url = `/${getCurrentCulture()}/auth/login?returnUrl=${currentUrl}`;

	if (additionalParam) {
		url += `&${additionalParam}`;
	}

	if (Array.from(searchParams.keys()).length > 0) {
		Array.from(searchParams.entries()).map(
			([key, value]) => (url += `&${[key]}=${value}`)
		);
	}

	return url;
}

/**
 * @param additionalParam additional search param for easier redirect behavior
 */
export function redirectToLogin(additionalParam?: string) {
	let url = getLoginReturnUrl(additionalParam);

	redirect(url);
}
